import React from 'react'
import audiobookImage from "../../../assets/img/audiobook.svg";

const SunsetMessage: React.FC = () => {
  return (
      <>
        {/* Background Image */}
        <div className="
        absolute
        bottom-[50px]
        w-auto
        h-auto

        lg:z-0
        lg:bottom-[30%]
        lg:left-[-80px]
        lg:w-2/5
        lg:max-w-[800px]
        ">
          <img
              src={audiobookImage}
              alt="Audiobook background illustration"
              className="w-full h-full object-contain"
          />
        </div>
        <div className="w-[560px] flex flex-col items-center min-h-[850px] lg:min-h-[650px]">
          <h1 className="font-apropal text-[48px] text-black font-bold mb-4 text-left md:text-center w-full">
            Od audiobooka do książki
          </h1>

          <p className="font-open-sans mb-8 text-left w-full">
            Wszystko zaczęło się od darmowego audiobooka, który nagrałem i wrzuciłem na streamingi.
            <br />
            <br />
            Dzięki Waszemu odzewowi „Zuchy" doczekały się papierowego wydania — premiera planowana jest na koniec roku.
            <br />
            <br />
            Audiobook zniknął ze streamingów, żeby zrobić miejsce wersji książkowej, ale historia żyje dalej. Obserwujcie mnie na <a target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=61584035175975" className="font-bold hover:text-gray-600">facebooku</a>, a dam znać, gdy tylko książkę będzie można zamówić.
          </p>
        </div>
      </>
  )
}

export default SunsetMessage
